module.exports = __webpack_public_path__ + "static/media/hz_tu3.4c85986d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hz_tu3.jpg
// module id = 1590
// module chunks = 10